export interface IForm_Fields {
  label?: string;
  name?: string;
}

export enum WirecountTypes {
  form15 = 1,
  form16,
  form17,
  form18,
  form19,
  form20
}

export enum E_Form_Type {
  "Form 15 - Wirecount Grid Sheet - BusBar and Terminal Wire" = 1,
  "Form 16 - Wirecount Grid Sheet - BR930 Series Relay Base",
  "Form 17 - Wirecout Grid Sheet - Cable Core",
  "Form 18 - Wirecount Grid Sheet - Multipurpose",
  "Form 19 - Cable Function Test Planning Sheet",
  "Form 20 - Wire Count Grid Sheet - WAGO Terminals",
}

export enum E_Wirecount_Key {
  "Key- Term=Terminal, T= Termination, A=Analysis, D=Diagram" = 1,
  "Key - R.S. ID= Relay Spade ID, T= Termination A=Analysis, D=Diagram",
  "Key - Term=Terminal, C= Core Number T= Termination, A=Analysis, D=Diagram",
  "Key - T= Termination, A=Analysis, D=Diagram",
  "",
  "Key - Term=Terminal, T= Termination, A=Analysis, D=Diagram",
}

// key Pair based on E_Form_Type Enum
export const Form_Fields = {
  1: [
    {
      label: "Signal Box",
      name: "signalBox",
    },
    {
      label: "Loc / Equip. Room",
      name: "locEquipRoom",
    },
    {
      label: "Bus Bar / Terminal ID",
      name: "busBarTerminalId",
    },
  ],
  2: [
    {
      label: "Signal Box",
      name: "signalBox",
    },
    {
      label: "Loc / Equip. Room",
      name: "locEquipRoom",
    },
    {
      label: "Relay",
      name: "relay",
    },
    {
      label: "Position",
      name: "position",
    },
    {
      label: "Function Left",
      name: "functionLeft",
    },
    {
      label: "Function Right",
      name: "functionRight",
    },
  ],
  3: [
    {
      label: "Signal Box",
      name: "signalBox",
    },
    {
      label: "Loc / Equip. Room",
      name: "locEquipRoom",
    },
    {
      label: "Cable ID",
      name: "cableId",
    },
    {
      label: "Row/Link ID",
      name: "rowLinkId",
    },
    {
      label: "Cable From",
      name: "cableFrom",
    },
    {
      label: "Cable To",
      name: "cableTo",
    },
    {
      label: "Cable Size",
      name: "cableSize",
    },
    {
      label: "Cable Type",
      name: "cableType",
    },
  ],

  4: [
    {
      label: "Signal Box",
      name: "signalBox",
    },
    {
      label: "Loc / Equip. Room",
      name: "locEquipRoom",
    },
    {
      label: "Equipment Id",
      name: "equipmentId",
    },
    {
      label: "Cable ID",
      name: "cableId",
    },
    {
      label: "Cable From",
      name: "cableFrom",
    },
    {
      label: "Cable To",
      name: "cableTo",
    },
  ],

  5: [
    {
      label: 'Cable ID',
      name: 'cableId',
    },
    {
      label: 'Cable Size',
      name: 'cableSize',
    },
    {
      label: 'Cable From',
      name: 'cableFrom',
    },
    {
      label: 'Cable To',
      name: 'cableTo',
    },
  ],

  6: [
    {
      label: "Signal Box",
      name: "signalBox",
    },
    {
      label: "Loc / Equip. Room",
      name: "locEquipRoom",
    },
    {
      label: "Cable ID",
      name: "cableId",
    },
    {
      label: "Row/Link ID",
      name: "rowLinkId",
    },
    {
      label: "Cable From",
      name: "cableFrom",
    },
    {
      label: "Cable To",
      name: "cableTo",
    },
    {
      label: "Cable Size",
      name: "cableSize",
    },
    {
      label: "Cable Type",
      name: "cableType",
    },
  ],
};

export const ApproverLevel = [
 {
    level: 1,
    status: 5,
    buttons: [
      {
        email: false,
        label: "L2 Approve"
      },
      {
        email: true,
        id: 'L2',
        label: "Forward to L2"
      },
      {
        email: true,
        id: 'L3',
        label: "Forward to L3"
      }
    ]
  },
  {
    level: 2,
    status: 5,
    buttons: [
      {
        email: false,
        label: "L2 Approve"
      },
      {
        email: true,
        id: 'L3',
        label: "Forward to L3"
      }
    ]
  },
  {
    level: 3,
    status: 6,
    buttons: [
      {
        email: false,
        label: "L3 Approve"
      }
    ]
  }
]
